interface FormData {
  name: string;
  email: string;
  company: string;
  elevatorPitch: string;
}

interface StepAboutYouProps {
  form: FormData;
  update: (field: string, value: string) => void;
  emailWarning: boolean;
  setEmailWarning: (v: boolean) => void;
  emailOverridden: boolean;
  setEmailOverridden: (v: boolean) => void;
}

const StepAboutYou = ({
  form,
  update,
  emailWarning,
  setEmailWarning,
  emailOverridden,
  setEmailOverridden,
}: StepAboutYouProps) => {
  return (
    <div className="flex flex-col gap-6 px-6 py-5">
      <div>
        <p className="font-heading text-ts-base text-foreground mb-1">
          Let's start with the basics
        </p>
        <p className="font-body text-ts-xs text-foreground/60">
          Tell me a little about yourself.
        </p>
      </div>

      <div>
        <label className="font-body text-ts-2xs font-medium tracking-[0.1em] text-muted-foreground mb-1.5 block">
          Name *
        </label>
        <input
          type="text"
          required
          maxLength={100}
          value={form.name}
          onChange={(e) => update("name", e.target.value)}
          className="w-full bg-transparent border-b border-border py-2 font-body text-ts-xs text-foreground placeholder:text-foreground/30 focus:border-primary focus:outline-none transition-colors"
          placeholder="Your name"
        />
      </div>

      <div>
        <label className="font-body text-ts-2xs font-medium tracking-[0.1em] text-muted-foreground mb-1.5 block">
          Email *
        </label>
        <input
          type="email"
          required
          maxLength={255}
          value={form.email}
          onChange={(e) => update("email", e.target.value)}
          className={`w-full bg-transparent border-b py-2 font-body text-ts-xs text-foreground placeholder:text-foreground/30 focus:outline-none transition-colors ${
            emailWarning ? "border-destructive" : "border-border focus:border-primary"
          }`}
          placeholder="you@company.com"
        />
        {emailWarning && (
          <div className="mt-2 flex items-start gap-2">
            <p className="font-body text-ts-2xs text-destructive flex-1">
              This doesn't look like a valid email. Is it correct?
            </p>
            <button
              type="button"
              onClick={() => {
                setEmailOverridden(true);
                setEmailWarning(false);
              }}
              className="font-body text-ts-2xs font-medium text-foreground underline underline-offset-2 whitespace-nowrap hover:text-primary transition-colors"
            >
              Yes, submit anyway
            </button>
          </div>
        )}
      </div>

      <div>
        <label className="font-body text-ts-2xs font-medium tracking-[0.1em] text-muted-foreground mb-1.5 block">
          Company / Brand
        </label>
        <input
          type="text"
          maxLength={100}
          value={form.company}
          onChange={(e) => update("company", e.target.value)}
          className="w-full bg-transparent border-b border-border py-2 font-body text-ts-xs text-foreground placeholder:text-foreground/30 focus:border-primary focus:outline-none transition-colors"
          placeholder="Optional"
        />
      </div>

      <div>
        <label className="font-body text-ts-2xs font-medium tracking-[0.1em] text-muted-foreground mb-1.5 block">
          What do you do?
        </label>
        <textarea
          maxLength={300}
          rows={3}
          value={form.elevatorPitch}
          onChange={(e) => update("elevatorPitch", e.target.value)}
          className="w-full bg-transparent border-b border-border py-2 font-body text-ts-xs text-foreground placeholder:text-foreground/30 focus:border-primary focus:outline-none transition-colors resize-none"
          placeholder="Give me the elevator pitch — what's your brand about?"
        />
      </div>
    </div>
  );
};

export default StepAboutYou;
